import React, { useState } from 'react'

import Paper from 'components_new/atoms/Paper'

import WidgetBase from 'components_new/organisms/Widget/WidgetBase'
import WidgetHeader from 'components_new/organisms/Widget/WidgetHeader'
import WidgetBody from 'components_new/organisms/Widget/WidgetBody'
import WidgetFooter from 'components_new/organisms/Widget/WidgetFooter'

import { TCustomization } from 'types/GlobalCustomization'
import {
  FormattedWidgetData,
  TCoreWidgetFullyLoaded,
  WidgetOrder
} from 'types/GlobalWidget'
import { ThemeProvider } from '@mui/material'
import { getTheme, getWidgetMode } from 'themes'
import { DashboardVariantType } from 'types/GlobalDashboard'

const SCALE_FACTOR = 0.75

const PreviewWidget = (props: {
  customization?: TCustomization | null
  formattedData: FormattedWidgetData
  widget: TCoreWidgetFullyLoaded
}) => {
  const { customization, formattedData, widget } = props
  const widgetMode = getWidgetMode(customization)
  const [order, setOrder] = useState<WidgetOrder>({
    id: null,
    index: null,
    dir: 'asc'
  })

  return (
    <ThemeProvider theme={getTheme(widgetMode, customization)}>
      <Paper
        variant="outlined"
        sx={{ bgcolor: 'background.widget', height: 264, p: 1 }}
      >
        <WidgetBase
          customization={customization}
          editMode={false}
          plain={true}
          scaleFactor={SCALE_FACTOR}
          title={widget.title}
          widgetType={widget.type}
        >
          <WidgetHeader
            editMode={false}
            scaleFactor={SCALE_FACTOR}
            updateWidget={() => {}}
            widget={widget}
          />
          <WidgetBody
            dashboardFilter={[]}
            editMode={false}
            embedded={true}
            fakeLoading={false}
            formattedData={formattedData}
            fullSize={false}
            interactive={true}
            isAdmin={false}
            order={order}
            periodFilter={null}
            scaleFactor={SCALE_FACTOR}
            customSegmentBy={null}
            setDashboardFilter={() => {}}
            showUnderlyingContent={() => {}}
            setEdit={() => {}}
            setCustomSegmentBy={() => {}}
            setOrder={setOrder}
            setViewport={() => {}}
            standaloneWidget={true}
            updateWidget={() => {}}
            variantType={DashboardVariantType.PUBLIC}
            viewport={{
              longitude: widget.settings.viewport.longitude,
              latitude: widget.settings.viewport.latitude,
              pitch: widget.settings.viewport.pitch,
              zoom: widget.settings.viewport.zoom
            }}
            widget={widget}
          />
          <WidgetFooter
            customPeriodFilter={null}
            embedded={true}
            interactive={true}
            periodFilter={null}
            scaleFactor={SCALE_FACTOR}
            widget={widget}
          />
        </WidgetBase>
      </Paper>
    </ThemeProvider>
  )
}

export default PreviewWidget
